module.exports = __webpack_public_path__ + "static/sample-17-686a4f2ff24fdbc265be408336336c20.png";